export default __webpack_public_path__ + "static/media/Sim-Sample-Upload.49356cb3.xlsx";